// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent_2/work/861f9e7e0cb825c7/node_modules/core-js/modules/es6.reflect.own-keys.js
// module id = wJYt
// module chunks = 15